<template>
  <div
    id="app"
    :style="{ zoom: appZoom }"
  >
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',
  data () {
    return {
      appZoom: 1
    }
  },
  mounted () {
    // 1440 810
    this.pageResize()
    setTimeout(() => {
      this.pageResize()
    }, 0)
    window.onresize = () => {
      this.pageResize()
    }
  },
  methods: {
    pageResize () {
      let cWidth = document.documentElement.clientWidth
      let cHeight = document.documentElement.clientHeight
      console.log(cWidth, cHeight)
      this.appZoom = cWidth / 1440
    },
  },
  destroyed () {
    window.onresize = null;
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* 加载背景图 */
  background-image: url('@/assets/images/starfield.jpg');
  /* 背景图垂直、水平均居中 */
  background-position: center center;
  /* 背景图不平铺 */
  background-repeat: no-repeat;
  /* 当内容高度大于图片高度时，背景图像的位置相对于viewport固定 */
  background-attachment: fixed;
  /* 让背景图基于容器大小伸缩 */
  background-size: cover;
  /* 设置背景颜色，背景图加载过程中会显示背景色 */
  background-color: #464646;

  width: 1440px;
  height: 810px;
}
</style>
